module.exports = __webpack_public_path__ + "pc/img/rec_14.ddda3419.svg";